/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OAuthRefreshTokenCredentials = {
  refreshToken: string;
};

/** @internal */
export const OAuthRefreshTokenCredentials$inboundSchema: z.ZodType<
  OAuthRefreshTokenCredentials,
  z.ZodTypeDef,
  unknown
> = z.object({
  refresh_token: z.string(),
}).transform((v) => {
  return remap$(v, {
    "refresh_token": "refreshToken",
  });
});
/** @internal */
export type OAuthRefreshTokenCredentials$Outbound = {
  refresh_token: string;
};

/** @internal */
export const OAuthRefreshTokenCredentials$outboundSchema: z.ZodType<
  OAuthRefreshTokenCredentials$Outbound,
  z.ZodTypeDef,
  OAuthRefreshTokenCredentials
> = z.object({
  refreshToken: z.string(),
}).transform((v) => {
  return remap$(v, {
    refreshToken: "refresh_token",
  });
});

export function oAuthRefreshTokenCredentialsToJSON(
  oAuthRefreshTokenCredentials: OAuthRefreshTokenCredentials,
): string {
  return JSON.stringify(
    OAuthRefreshTokenCredentials$outboundSchema.parse(
      oAuthRefreshTokenCredentials,
    ),
  );
}
export function oAuthRefreshTokenCredentialsFromJSON(
  jsonString: string,
): SafeParseResult<OAuthRefreshTokenCredentials, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OAuthRefreshTokenCredentials$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OAuthRefreshTokenCredentials' from JSON`,
  );
}
